module.exports = __webpack_public_path__ + "img/HPS008CP.f63ba30b.png";